import { render, staticRenderFns } from "./VoteKickListCard.vue?vue&type=template&id=475863bc&"
import script from "./VoteKickListCard.vue?vue&type=script&lang=js&"
export * from "./VoteKickListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports